import axios from 'axios'

export default {
  state: {
    productInfo: {},
    warranty: {},
    availabilityInShops: [],
    isAvailableShopInSelectedCity: false,
    setsWithProduct: [],
    isLoading: false,
    error: '',
    message: '',
    recommendedProducts: {
      title: '',
      data: []
    }
  },
  getters: {
    initSlideIndex (state) {
      // Возвращает индекс первого слайда с картинокй. Если все 5 слайдов это видео, то возвращает 0
      let initSlide = 0
      for (let i = 0; i < state.productInfo.shortPhotoList.length; i++) {
        if (state.productInfo.shortPhotoList[i].origin_photo) {
          initSlide = i
          break
        }
      }
      return initSlide
    }
  },
  mutations: {
    SET_RECOMMENDED_PRODUCTS: (state, data) => {
      state.recommendedProducts = data
    },
    SET_PRODUCT_INFO: (state, object) => {
      state.productInfo = object
    },
    UPDATE_PRODUCT_INFO: (state, data) => {
      state.productInfo = { ...state.productInfo, ...data }
    },
    SET_PRODUCT_WARRANTY: (state, obj) => {
      state.warranty = obj
    },
    SET_PRODUCT_AVAILABILITY_IN_SHOPS: (state, array) => {
      state.availabilityInShops = array
    },
    SET_IS_AVAILABLE_SHOPS_IN_CITY: (state, bool) => {
      state.isAvailableShopInSelectedCity = bool
    },
    SET_LOADING: (state, bool) => {
      state.isLoading = bool
    },
    SET_ERROR: (state, message) => {
      state.error = message
    },
    SET_MESSAGE: (state, message) => {
      state.message = message
    },
    SET_SETS_WITH_PRODUCT: (state, sets) => {
      state.setsWithProduct = sets
    }
  },
  actions: {
    SET_RECOMMENDED_PRODUCTS: ({ commit }, data) => {
      commit('SET_RECOMMENDED_PRODUCTS', data)
    },
    CHANGE_PRODUCT_INFO: ({ commit }, object) => {
      commit('SET_PRODUCT_INFO', object)
    },
    UPDATE_PRODUCT_INFO_ACTION: ({ commit }, data) => {
      commit('UPDATE_PRODUCT_INFO', data)
    },
    FETCH_PRODUCT_WARRANTY: async ({ commit, rootGetters }, productId) => {
      const params = {
        productId: productId
      }

      await axios
        .get(rootGetters.urlLanguagePrefix + '/shop/catalog/get-product-service-maintenance/', { params })
        .then(res => {
          if (res.data.success) {
            commit('SET_PRODUCT_WARRANTY', res.data.warranty)
          } else {
            commit('SET_ERROR', res.data.message)
          }
        })
        .catch(err => {
          commit('SET_ERROR', err.message)
        })
        .finally(() => {
          commit('SET_ERROR', '')
        })
    },
    FETCH_PRODUCT_AVAILABILITY_IN_SHOPS: ({ commit, rootGetters }, { productId, cityId }) => {
      const params = {
        product_id: productId,
        city_id: cityId
      }

      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/catalog/get-warehouse-balances/', { params })
          .then(res => {
            if (res.data) {
              // eslint-disable-next-line no-unused-expressions
              res.data?.stores?.forEach(store => {
                commit('waitlist/SET_WAIT_LIST_STATUS_IN_SHOPS', store, { root: true })
              })
              commit('SET_PRODUCT_AVAILABILITY_IN_SHOPS', res.data.stores)
              commit('SET_IS_AVAILABLE_SHOPS_IN_CITY', res.data.has_stores)
            }

            resolve(res)
          })
          .catch(err => {
            commit('SET_ERROR', err.message)
            reject(err)
          })
          .finally(() => {
            commit('SET_ERROR', '')
          })
      })
    },
    FETCH_SETS_WITH_PRODUCT: ({ rootGetters, commit }, productId) => {
      const params = {
        id: productId
      }

      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/catalog/get-sets-contained-product/', { params })
          .then(res => {
            if (res.data?.success) {
              commit('SET_SETS_WITH_PRODUCT', res.data.data)
            }
            resolve(res)
          })
          .catch(err => {
            commit('SET_ERROR', err.message)
            reject(err)
          })
          .finally(() => {
            commit('SET_ERROR', '')
          })
      })
    }
  }
}
